import { CheckoutStep } from '../../../../Purchase/Checkout/CheckoutStep.csharp';
import { CartItemViewModel } from '../../Cart/Item/ViewModels/CartItemViewModel.csharp';
import { DeliveryMethodAvailability } from '../Delivery/DeliveryMethods/DeliveryMethodAvailability.csharp';
import { CheckoutViewModel } from '../ViewModel/CheckoutViewModel.csharp';
import { deliveryMethodValidator } from './DeliveryMethodValidator';

export const validateCheckout = (checkout: CheckoutViewModel, checkoutStep: CheckoutStep): string[] => {
    const errors = [];

    if (checkoutStep >= CheckoutStep.Delivery) {
        if (!checkout.addresses.selectedAddressId) {
            errors.push('checkout.shippingMethodAvailability.AddressNotSelected');
        }

        const selectedShipping = checkout.delivery.selectedDeliveryMethod;
        if (!selectedShipping) {
            errors.push('checkout.shippingMethodAvailability.DeliveryMethodNotSelected');
            return errors;
        }

        if (selectedShipping.methodAvailability != DeliveryMethodAvailability.Ok) {
            errors.push('checkout.shippingMethodAvailability.' + DeliveryMethodAvailability[selectedShipping.methodAvailability]);
            return errors;
        }

        deliveryMethodValidator.validate(checkout, errors);
    }

    return errors;
};

export const containsQuantityWarnings = (item: CartItemViewModel): boolean => {
    for (const error of item.validationIssues) {
        if (error?.code === 'AdjustedQuantityByAvailableQuantity' || error?.code === 'AdjustedQuantityByOtcLimitQuantity') {
            return true;
        }
    }

    return false;
};

export const containsOnlyQuantityWarnings = (item: CartItemViewModel): boolean => {
    for (const error of item.validationIssues) {
        if (error?.code !== 'AdjustedQuantityByAvailableQuantity' && error?.code !== 'AdjustedQuantityByOtcLimitQuantity') {
            return false;
        }
    }

    return true;
};
